import { Icon, IconsEnum } from 'components/Icons';

import { Dialog } from 'components/dialog';
import { SportTicket } from '../../utils/calcoloCarrello/types';
import { selectTicket } from '../../sportTicketSelectors';
import styles from './ConfirmationModal.module.scss';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

type ConfirmationModalProps = {
  // eslint-disable-next-line no-unused-vars
  onConfirm: (updatedTicket: SportTicket) => void;
  onCancel: () => void;
  isOpened: boolean;
};

export const ConfirmationModal = ({ onCancel, onConfirm: onConfirmParent, isOpened }: ConfirmationModalProps) => {
  // NOTE: This confirmation modal is available only for sport ticket due to gold payment method
  const sportTicket = useTypedSelector(selectTicket);

  const [allGoldTitleLabel, allGoldSubtitleLabel, allGoldCancelLabel, allGoldConfirmLabel] = useGetLabelsByKeys([
    'all-gold-title',
    'all-gold-subtitle',
    'all-gold-cancel',
    'all-gold-confirm',
  ]);

  const { isMobile } = useWindowSize();

  if (!isOpened) return;

  const onConfirm = () => {
    const updatedTicket: SportTicket = { ...sportTicket, flagBw: 1, settaPrioGold: 1 };
    // dispatch(ticketUpdated(updatedTicket));
    onConfirmParent(updatedTicket);
  };

  return (
    <Dialog open={isOpened} onCloseClick={() => onCancel()} isMobileFullScreen={isMobile} hasTrigger>
      <div className={styles.container}>
        <Icon iconId={IconsEnum.INFO} className={`${styles.icon}`} />
        <p className={styles.title}>{allGoldTitleLabel}</p>
        <p
          className={styles.subTitle}
          dangerouslySetInnerHTML={{ __html: allGoldSubtitleLabel }}
          suppressHydrationWarning
        />
        <div className={styles.buttonsDialog}>
          <button className={styles.cancel} onClick={() => onCancel()}>
            {allGoldCancelLabel}
          </button>
          <button className={styles.confirm} onClick={() => onConfirm()}>
            {allGoldConfirmLabel}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
